import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
    selector: 'app-members-delete',
    templateUrl: './question-delete.component.html'
})
export class QuestionDeleteComponent {
    dialogTitle: string;
    text: string;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        this.dialogTitle = this.data.question.question;
        this.text = this.data.question.answer;
    }
}
